<template>
<moo-dialog custom-class="common-dialog download-dialog" :append-to-body="true" :visible.sync="visible">
    <div class="content">
      <div class="header">
        <div class="title">{{$t("文件下载#!!!#src/pages/H5/Cloud/components/dialog/FileDownloadDialog.vue_1")}}</div>
        <div class="close" @click="handleDownloadDialogVisible(false, null)">
          <downloadClose></downloadClose>
        </div>
      </div>
      <div class="body">
        <div class="desc">
          <div class="icon">
            <svg-icon :icon-class="getFileIcon(item)"></svg-icon>
          </div>
          <div class="name">{{ fileName }}</div>
        </div>
        <div class="operation">
          <div class="browser" @click="downloadFromBrowser">
            <div class="title">{{$t("继续用浏览器下载#!!!#src/pages/H5/Cloud/components/dialog/FileDownloadDialog.vue_1")}}</div>
          </div>
          <div class="client" @click="downloadFromClient">
            <div class="title">{{$t("同程管家客户端下载#!!!#src/pages/H5/Cloud/components/dialog/FileDownloadDialog.vue_1")}}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="tip">{{$t("同程管家客户端下载更快，大文件推荐优先使用。如未安装，可继续用浏览器下载。#!!!#src/pages/H5/Cloud/components/dialog/FileDownloadDialog.vue_1")}}        </div>
      </div>
    </div>
  </moo-dialog>
</template>

<script>
import downloadClose from "../../assets/downloadClose.vue";
import { fileImgName } from "@/utils/avatar";

export default {
  name: "FileDownloadDialog",
  props: {},
  emits: ["downloadFromBrowser"],
  components: {
    downloadClose,
  },
  data() {
    return {
      visible: false,
      item: null,
      isFolder: false, // 是否是文件夹
    };
  },
  computed: {
    fileName() {
      if (!this.item) return "";
      return this.item.fileName;
    },
  },
  methods: {
    handleDownloadDialogVisible(value, fileInfo, isFolder = false) {
      this.item = fileInfo || null;
      this.isFolder = isFolder;
      this.visible = value;
    },
    downloadFromBrowser() {
      this.$emit("downloadFromBrowser", this.item.fileId, this.isFolder);
      this.visible = false;
    },
    downloadFromClient() {
      const url = `toca://clouddisk?fileId=${this.item.fileId}&action=download`;
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("target", "_self");
      document.body.appendChild(link);
      link.click();
      setTimeout(() => document.body.removeChild(link), 200);
      this.visible = false;
    },
    getFileIcon(item) {
      if (!item) return "cloud-other";
      const { fileName, type, contentType = "" } = item;
      if (contentType == "DOCUMENT") {
        return "cloud-online-doc";
      }
      if (type !== "0") return "cloud-folder";
      const name = fileName.trim();
      const index = name.lastIndexOf(".");
      if (index === -1) return "cloud-other";
      const ext = name
        .substr(index)
        .replace(".", "")
        .toLowerCase();
      return fileImgName(ext);
    },
  },
};
</script>

<style lang="scss">
.download-dialog {
  width: 609px !important;
  height: 281px !important;
  .moo-dialog__body {
    height: 100%;
    .content {
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .header {
        height: 72px;
        margin: 0 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        .title {
          height: 24px;
          font-weight: 600;
          font-size: 16px;
          color: #121317;
          line-height: 24px;
        }
        .close {
          width: 24px;
          height: 24px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &:hover {
            background-color: #f4f6f9;
          }

          svg {
            width: 14px;
            height: 14px;
          }
        }
      }
      .body {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 24px;
        .desc {
          margin-top: 16px;
          margin-bottom: 40px;
          display: flex;
          align-items: center;
          .icon {
            width: 36px;
            height: 36px;
            margin-right: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            svg {
              width: 36px;
              height: 36px;
            }
          }
          .name {
            max-width: 500px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #222329;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .operation {
          margin-bottom: 40px;
          display: flex;
          .browser {
            width: 190px;
            height: 44px;
            background: #ffffff;
            border: 1px solid #d5d5d5;
            border-radius: 6px;
            margin-right: 12px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background-color: #f4f6f9;
              border: 1px solid #d5d5d5;
            }

            .title {
              font-weight: 500;
              font-size: 14px;
              color: #222329;
              text-align: center;
              line-height: 20px;
            }
          }
          .client {
            width: 190px;
            height: 44px;
            background: #5c70ff;
            border-radius: 6px;
            border: 1px solid #5c70ff;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background-color: #6d7dff;
              border: 1px solid #6d7dff;
            }

            .title {
              font-weight: 500;
              font-size: 14px;
              color: #ffffff;
              text-align: center;
              line-height: 20px;
            }
          }
        }
      }
      .footer {
        height: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        background-color: #f6f6f6;
        .tip {
          font-weight: 400;
          font-size: 12px;
          color: #93949c;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
